module.exports = __webpack_public_path__ + "media/images/certificates/certificat-02-1315c9abe306ad069a4e4dde4740e636.png";